module.exports = __webpack_public_path__ + "images/3f9de1a196817c0e3bd674723fac8567.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/memoji_404.png
// module id = 54
// module chunks = 0